export default "__VITE_ASSET__0Yd8ePdd__"